import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/cn';
const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-12 w-12 border-4',
};
export function Spinner({ size = 'md', className }) {
    return (_jsx("div", { role: "status", "aria-label": "Cargando", className: cn('animate-spin rounded-full border-current border-t-transparent', sizeClasses[size], className) }));
}
//# sourceMappingURL=Spinner.js.map